import { Badge, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_STATE } from "../../../../actions/types";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { getPermissions, updateKeyInMasterClass } from '../../../../app/util';

const FeederMarketButton = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const state = useSelector((appState) => appState);
    const {
        profile: { property_details },
        user,
    } = useSelector((state) => state.auth);

    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );

    const { property_id } = app_state;
    const { permissions } = getPermissions(property_details, property_id);

    const handleReportId = (id) => {
        const { property_id, property_name, workspace_controls, primary_stay_range } = app_state;
        const formatted_stay_date = moment().format('YYYY-MM-DD');//dateFormat(moment(), "YYYY-MM-DD");
        window.analyze.track("flight_sigma_analytics_report", {
            "selected_tile": ui_state.active_tiles.join(),
            property_id, property_name,
            stay_date: formatted_stay_date
        }, {}, {
            app_state: {
                workspace_controls,
            },
            ui_state: {
            }
        });
        updateKeyInMasterClass("sigma_report_id", id);
        localStorage.setItem("sigma_report_id", id)

        // lrv-1095 open report in new tab
        setTimeout(() => {
            const newUrl = window.top.location.origin + '/feeder-market-reports';
            window.open(newUrl, '_blank');
        }, 1000);
    }
   let  reportId = "flight_ea";
    return (
        <Box className="feeder-market-container">
            <Badge className='feeder-market-badge' badgeContent={'New'} color="error">
                <Button className="feeder-market-btn" onClick={() => handleReportId(reportId)}>
                    Feeder Market Insights
                </Button>
            </Badge>
        </Box>
    )
}

export default FeederMarketButton